import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 25 31" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M2 31h21a2 2 0 002-2V9.854a2 2 0 00-.617-1.445L20.3 4.5 16.077.54A2 2 0 0014.709 0H2a2 2 0 00-2 2v27a2 2 0 002 2zm1-2h19a1 1 0 001-1V11.2h-9.3a.5.5 0 01-.5-.5V2H3a1 1 0 00-1 1v25a1 1 0 001 1zM23 9.5L15 2v7a.5.5 0 00.5.5H23z" fill="#000" /></svg>);